<script>
// import axios from "axios";

import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import { ModelListSelect } from "vue-search-select";
import appConfig from "@/app.config";
import { mapGetters, mapActions } from "vuex";
import moment from "moment";
import DataTable from "@/components/DataTable.vue";


/**
 * Advanced table component
 */
export default {
  page: {
    title: "Consumables Stock Movement",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    ModelListSelect,
    DataTable,
  },
  data() {
    return {
      title: "Consumables Stock Movement Report",
      items: [
        {
          text: "Home",
          href: "#/",
        },
        {
          text: "Consumables Stock Movement",
          active: true,
        },
      ],
      totalRows: 1,

      pageOptions: [10, 25, 50, 100, 200, 1000],
      IsStockMovementServerPaginated: true,
      serverPerPage: 50,
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      fields: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "product",
          sortable: true,
          label: "PRODUCT",
        },
        {
          key: "from_quantity",
          sortable: true,
          label: "OLD QUANTITY",
        },
        {
          key: "qty_in",
          sortable: true,
          label: "QTY IN",
        },
        {
          key: "qty_out",
          sortable: true,
          label: "QTY OUT",
        },
        {
          key: "balance",
          sortable: true,
          label: "STOCK BALANCE",
        },
        {
          key: "typename",
          sortable: true,
          label: "TYPE",
        },
        {
          key: "user",
          sortable: true,
          label: "MADE BY",
        },
        {
          key: "date",
          sortable: true,
          label: "DATE",
        },
        {
          key: "date_recorded",
          sortable: true,
          label: "RECORDED ON",
        },
      ],
      currentdate: moment(new Date()).format("YYYY-MM-DD"),
      data: {
        dateto: moment(new Date()).format("YYYY-MM-DD"),
        datefrom: moment().subtract(1, 'months').format('YYYY-MM-DD'),
        type: "",
        id:atob(this.$route.params.id),
        page: 1,
        per_page: 50,
      },
      totals:{
        total_in:0,
        total_out:0,
        total_balance:0,
      }, 
      filterTitle: "",
      types: [
        {name: "All Types",id: ""},
        {name: "Opening Stock",id: 1},
        {name: "Purchase",id: 2},
        {name: "Usage",id: 3},
        {name: "Spoilt Stock",id: 4},
        {name: "Reconciled",id: 5},
        {name: "Expired",id: 6},
      ],

      json_fields: {
        PRODUCT: "product",
        FROM_QUANTITY: "from_quantity",
        QUANTITY_IN: "qty_in",
        QUANTITY_OUT: "qty_out",
        STOCK_BALANCE: "balance",
        TYPE: "typename",
        DESCRIPTION: "description",
        MADE_BY: "user",
        DATE: "date",
        RECORDED_ON: "date_recorded"
      },
      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8",
          },
        ],
      ],
    };
  },

  computed: {
    ...mapGetters("consumables", ["StockMovement","filterStatus","StockMovementPagination","StockMovementPaginated","StockMovementSummary"]),

    rows() {
      return this.IsStockMovementServerPaginated
        ? this.StockMovementPagination.total
        : this.StockMovementPaginated
        ? this.StockMovementPaginated.length
        : 0;
    },

    perPage: {
      get() {
        if (this.IsStockMovementServerPaginated) {
          return (
            (this.StockMovementPagination && this.StockMovementPagination.per_page) ||
            this.data.per_page ||
            this.serverPerPage
          );
        } else {
          return this.serverPerPage;
        }
      },
      set(value) {
        if (this.IsStockMovementServerPaginated) {
          this.data.per_page = value;
          this.data.page = 1;
          this.FetchMovements(this.data);
        } else {
          this.serverPerPage = value;
        }
      },
    },

    currentPage: {
      get() {
        return this.StockMovementPaginated && this.StockMovementPagination
          ? this.StockMovementPagination.current_page
          : 1;
      },
      set(value) {
        if (this.StockMovementPaginated) {
          this.data.page = value;
          this.handlePageChange(value);
        }
      },
    },
   
  },

  methods: {
    ...mapActions({
      FetchMovements: "consumables/fetchConsumableMovements",
    }),
    // COMMA SEPERATORS
    thousandSeprator(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
          .toString()
          .replace(/[^0-9.]+/g, "")
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },

    filterReport() {
      this.FetchMovements(this.data);
    },

    handlePageChange(newPage) {
      if (this.IsStockMovementServerPaginated) {
        this.data.page = newPage;
        this.FetchMovements(this.data);
      }
    },
  },

  updated(){
    if(this.StockMovement){
      let total_in = 0;
      let total_out = 0;
      this.StockMovement.forEach((item)=>{
        total_in = total_in+parseInt(item.qty_in);
        total_out = total_out+parseInt(item.qty_out);
      });
      this.totals.total_in = total_in;
      this.totals.total_out = total_out;
      this.totals.total_balance = total_in-total_out; 
    }
  },
  
  created() {
    this.FetchMovements(this.data);
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row py-3">
              <div class="col-md-9">
                <download-excel
                  class="btn btn-info"
                  :data="StockMovement"
                  :fields="json_fields"
                  :worksheet="'CONSUMABLES MOVEMENTS ON' + currentdate"
                  type="csv"
                  :name="'ConsumablesMovement_Report from ' +data.datefrom+' to '+data.dateto+'.xls'"
                >
                  Export Excel <i class="fa fa-download"></i>
                </download-excel>
              </div>
              <div class="col-md-3">          
                <button @click="$router.go(-1)" class="btn btn-primary btn-sm" >
                  <i class="fas fa-arrow-circle-left"></i> Go Back
                </button>
              </div>  
            </div>            
            <div class="row">
              <h4>
                <center>Consumables Stock Movements Report from{{ data.datefrom }} to {{ data.dateto }}</center>
              </h4>
              <div class="col-4">
                <div class="form-group">
                  <label>Movement Type</label>
                  <model-list-select
                    :list="types ? types : []"
                    v-model="data.type"
                    option-value="id"
                    option-text="name"
                    class="mb-3"
                    placeholder="Select Type"
                    @change="filterReport()"
                  >
                  </model-list-select>
                </div>
              </div>
              <div class="col-3">
                <div class="form-group">
                  <label>From</label>
                  <input
                    type="date"
                    v-model="data.datefrom"
                    class="form-control"
                    v-limit-future-date
                  />
                </div>
              </div>
              <div class="col-3">
                <div class="form-group">
                  <label>To</label>
                  <input
                    type="date"
                    v-model="data.dateto"
                    class="form-control"
                    v-limit-future-date
                  />
                </div>
              </div>
              <div class="col-2 mt-4">
                <button class="btn btn-primary" type="button" @click="filterReport()">
                  <span class="fa fa-filter"></span> Filter
                  <b-spinner
                    v-show="filterStatus"
                    variant="light"
                    small
                    role="status"
                  ></b-spinner>
                </button>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <DataTable
                :columns="fields"
                :rows="StockMovement || []"
                :total-rows="rows"
                :pagination="StockMovementPagination"
                :server-pagination="IsStockMovementServerPaginated"
                :loading="filterStatus"
              >
               <template #cell(index)="{ index }">
                  {{ (currentPage - 1) * perPage + index + 1 }}
                </template>
                <template #cell(amount_field)="{row}">
                  {{ thousandSeprator(row.amount) }}
                </template>
                <template #cell(mode_field)="{row}">
                  {{ row.mode.name }} ({{ row.mode.type_name }}-{{ row.mode.account_number }})
                </template>               
              </DataTable>
              <div class="row">
                <div class="col-md-4">
                  <h5>Total Qty In: <span class="text-danger">{{(totals.total_in).toLocaleString()}}</span></h5>
                </div>
                <div class="col-md-4">
                  <h5>Total Qty Out: <span class="text-danger">{{(totals.total_out).toLocaleString()}}</span></h5>
                </div>
                <div class="col-md-4">
                  <h5>Total Balance: <span class="text-danger">{{(totals.total_balance).toLocaleString()}}</span></h5>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
<style>
.btn-primary,.page-link { background-color:#FAB031 !important;border-color:#FAB031 !important;}
</style>
